import { createEl } from "@/client/utils/createEl";
import { textarea, type TextareaVariants } from "./textarea.css";

export interface TextareaOptions extends NonNullable<TextareaVariants> {
    placeholder?: string;
    value?: string;
    disabled?: boolean;
    rows?: number;
    onChange?: (value: string) => void;
    onInput?: (value: string) => void;
}

export const createTextarea = (
    options: TextareaOptions,
    init?: (el: HTMLTextAreaElement) => void,
): HTMLTextAreaElement => {
    const isDisabled = options.disabled ?? false;
    const state = isDisabled ? "disabled" : (options.state ?? "default");

    const className = textarea({
        theme: options.theme,
        state,
    });

    return createEl("textarea", className, [], (el) => {
        el.disabled = isDisabled;
        if (options.placeholder !== undefined) {
            el.placeholder = options.placeholder;
        }
        if (options.value !== undefined) {
            el.value = options.value;
        }
        if (options.rows !== undefined) {
            el.rows = options.rows;
        }
        if (options.onChange !== undefined) {
            el.addEventListener("change", () => {
                options.onChange?.(el.value);
            });
        }
        if (options.onInput !== undefined) {
            el.addEventListener("input", () => {
                options.onInput?.(el.value);
            });
        }
        init?.(el);
    });
};
